

























































































































import Vue from 'vue'
import { mapDeps } from '~/plugins/dependency-container/utils'
import CFormSelectOption from '~/components/shared/configurable/form/select/CFormSelectOption.vue'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import { computeFieldState } from '~/utils/form'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'

export default Vue.extend({
  components: { CFormSelectOption, FieldError },
  props: {
    downpayment: {
      type: [Number, String],
      default: null
    },
    mileage: {
      type: Number,
      default: null
    },
    duration: {
      type: Number,
      default: null
    },
    lease: {
      type: [Number, String],
      default: null
    },
    purchasePrice: {
      type: [Number, String],
      default: null
    },
    specs: {
      type: Object,
      required: true
    },
    error: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      leaseError: this.error?.lease,
      downpaymentError: this.error?.downpayment,
      mileageError: this.error?.mileage,
      durationError: this.error?.duration,
      // eslint-disable-next-line camelcase
      purchasePriceError: this.error?.purchase_price
    }
  },
  computed: {
    ...mapDeps({ formValidationBuilder: FormValidationBuilder }),
    durationOptions() {
      return this.specs.duration.values
    },
    mileageOptions() {
      return this.specs.mileage.values
    },
    purchasePriceIsValid() {
      return computeFieldState(this.purchasePriceError)
    },
    leasingIsValid() {
      return computeFieldState(this.leaseError)
    },
    downpaymentIsValid() {
      return computeFieldState(this.downpaymentError)
    }
  },
  methods: {
    conditionallyApplyRequiredClass(spec: any) {
      return spec.required ? 'required-form-group' : null
    },
    validateAll({
      downpayment = this.downpayment,
      lease = this.lease,
      mileage = this.mileage,
      duration = this.duration,
      purchasePrice = this.purchasePrice
    }) {
      const {
        downpayment: downpaymentSpecs,
        lease: leaseSpecs,
        mileage: mileageSpecs,
        duration: durationSpecs,
        purchase_price: purchasePriceSpecs
      } = this.specs

      this.downpaymentError = this.formValidationBuilder
        .new()
        .required(downpaymentSpecs.required, downpayment)
        .isNumeric(downpayment)
        .aboveMinNumber(downpaymentSpecs.min, downpayment)
        .validate()
      this.leaseError = this.formValidationBuilder
        .new()
        .required(leaseSpecs.required, lease)
        .isNumeric(lease)
        .aboveMinNumber(leaseSpecs.min, lease)
        .belowMaxNumber(leaseSpecs.max, lease)
        .validate()
      this.mileageError = this.formValidationBuilder
        .new()
        .required(mileageSpecs.required, mileage)
        .validate()
      this.durationError = this.formValidationBuilder
        .new()
        .required(durationSpecs.required, duration)
        .validate()

      this.purchasePriceError = this.formValidationBuilder
        .new()
        .required(purchasePriceSpecs.required, purchasePrice)
        .isNumeric(purchasePrice)
        .validate()
    },
    handleDownpaymentChange(downpayment: string) {
      this.validateAll({ downpayment })
      this.$emit('downpayment-change', downpayment)
    },
    handleLeaseChange(lease: string) {
      this.validateAll({ lease })
      this.$emit('lease-change', lease)
    },
    handleDurationChange(duration: number) {
      this.validateAll({ duration })
      this.$emit('duration-change', duration)
    },
    handleMileageChange(mileage: number) {
      this.validateAll({ mileage })
      this.$emit('mileage-change', mileage)
    },
    handlePurchasePriceChange(purchasePrice: string) {
      this.validateAll({ purchasePrice })
      this.$emit('purchase-price-change', purchasePrice)
    }
  }
})
